









































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SearchBar from '@/components/SearchBar.vue';
import Table from '@/components/Table.vue';
import UserService from '../services/user.service';
import { Action, Getter } from 'vuex-class';
import Dialog from '@/components/Dialog.vue';

@Component({
  components: {
    Dialog,
    Table,
    SearchBar,
  },
})
export default class UsersList extends Vue {
  @Prop() private editUser: any;
  @Prop() private bus: any;
  @Prop({ default: null }) private searchString!: string;
  @Action private addToastErrorMessage: any;
  @Getter private login: any;

  private preventConfirm: boolean = false;

  private modalHeader: string = '';
  private modalBody: string = '';
  private showModalConfirm: boolean = false;
  private handleModalConfirm: any = null;

  private users: any;
  private showDisposeAction: boolean = false;
  private showCheckboxes: boolean = true;
  private fixedHeader: boolean = false;
  private selected: any[] = [];

  private numRows: number = 15;
  private paginationOptions: number[] = [];

  private tableData: any = {
    headers: [
      {
        text: 'First Name',
        value: 'first_name',
        align: 'start',
        filterable: true,
      },
      { text: 'Last Name', value: 'last_name' },
      { text: 'Email', value: 'email', filterable: true },
      { text: 'Roles', value: 'roles' },
    ],
    total: 0,
    filters: {},
    distinctRows: {},
  };

  private async mounted() {
    this.calculateOptimalRowsNumber();
    await this.getAllUsers();
  }

  private async getAllUsers() {
    const { users } = await UserService.getUsersForOrganisation();
    this.users = users;
    await this.populateUsers();
  }

  private async populateUsers() {
    return new Promise((resolve, reject) => {
      const rows: any[] = [];
      const data = this.users;
      data.forEach((row: any) => {
        rows.push({
          id: row.id,
          first_name: row.first_name || '(invite pending)',
          last_name: row.last_name,
          email: row.email,
          roles: row.roles.map((role: any) => role.name),
          sortedRoles: row.roles
            .map((role: any) => {
              return { name: role.name, id: role.id };
            })
            .sort((a: any, b: any) => a.id - b.id),
          roleIds: row.roles.map((role: any) => role.id),
          // path: `/admin/settings/deviceType/${row.id}`,
        });
      });
      Vue.set(this.tableData, 'rows', rows);
      this.tableData
        ? resolve(this.tableData)
        : reject(this.addToastErrorMessage('Error resolving table data.'));
    });
  }

  private goToOrOpenDrawer(row: any) {
      if (row.path) {
        this.$router.push({ path: row.path });
      } else {
        this.bus.$emit('openDrawer', row);
        if (row.roles) {
          this.bus.$emit('rolesSelected', row.roleIds);
        }
      }
    }

  private checkboxValuesChanged(checkboxValues: any[]) {
    this.selected = checkboxValues;
    this.updateActionMenu();
  }

  private updateActionMenu() {
    if (this.selected.length) {
      this.showDisposeAction = true;
    } else {
      this.showDisposeAction = false;
    }
  }

  private calculateOptimalRowsNumber() {
    this.numRows = Math.floor((window.innerHeight / 32) - 8);
    this.paginationOptions = [5, 10, 50, -1, this.numRows].sort((a, b) => a - b);
  }

  private async disposeUsers() {
    this.showModalConfirm = true;
    this.modalHeader = 'Remove the selected users?';

    if (this.selected.length > 0) {
      this.preventConfirm = false;
      this.modalBody = `<div class="mb-5 bg-grey-light flex py-2 rounded border border-1">
                          <i class="text-grey-darker mdi mdi-alert-circle-outline mx-4 text-md-h5"></i>
                          <p class="my-auto text-grey-darker">You are about to remove the following ${
                            this.selected.length
                          } user${
        this.selected.length > 1 ? 's' : ''
      } from your organisation. Confirm to continue.</p>
                        </div>
                        <div>`;
      for (const user of this.selected) {
        this.modalBody += `<div class="border border-1 rounded mb-4">
                             <div class="bg-grey-light w-full">
                               <div class="py-2">
                                 <span class="text-body-4 text-grey-darker pa-4"><span class="text-capitalize">${user.first_name} ${user.last_name}</span> — ${user.email} `;
        this.modalBody += `</div>
                             </div>
                               <div class="flex">
                                 <div class="flex-grow h-full">
                                   <h4 class="h-4 py-4 px-6 text-sm mb-4 text-grey-darker">Assigned roles:
                                     <div class="float-right">`;
        user.sortedRoles.forEach((role: any, index: number) => {
          this.modalBody += `<span class="text-right">${role.name}${
            index !== user.sortedRoles.length - 1 ? '\xa0-\xa0' : ''
          }</span>`;
        });
        this.modalBody += `</div>
                          </h4>
                        </div>
                      </div>`;
        if (user.email === this.userDetails()) {
          this.modalBody += `<div class="text-body-2 error--text px-6 pb-4 text-sm"><i class="mdi mdi-alert-outline error--text pr-4"></i>This is your currently logged in user.</div>`;
        }
        this.modalBody += `</div>`;
      }
      this.modalBody += `</div>`;
    }
    this.handleModalConfirm = async () => {
      this.showModalConfirm = false;
      this.preventConfirm = true;

      await Promise.all(
        this.selected.map((user) => UserService.removeUser(user.id)),
      );

      this.showDisposeAction = false;
      this.selected = [];
      this.updateActionMenu();

      await this.getAllUsers();

      // this.$router.go(0);
      return;
    };
  }

  private getColor(role: any) {
    switch (role.name) {
      case 'Super Admin':
        return 'rgba(1,110,161,0.6)';
      case 'Organisation Admin':
        return '#016EA1';
      case 'User':
        return 'rgba(1,110,161,0.4)';
      default:
        return 'primary';
    }
  }

  private userDetails() {
    if (!this.login || !this.login.details) {
      return '-';
    } else {
      return `${this.login.details.email}`;
    }
  }

  private doModalConfirm() {
    return this.handleModalConfirm === null ? false : this.handleModalConfirm();
  }
}
